import SceneBase from '~/engine/src/SceneBase';

class YoshisIsland2 extends SceneBase {
	constructor() {
		super();
	}
}

export default YoshisIsland2;
